import { orderBy, query } from 'firebase/firestore';
import { useMemo } from 'react';
import { useCollection, useDoc } from '@/lib/firestore/hooks';
import { companiesCol, companyActivityCol, companyDoc } from '@/lib/firestore/refs';
import type { Company, CompanyActivity } from '@shared/types';

/** All companies by name; status and parent filters are applied client-side (no composite index needed). */
export function useCompanies(status: 'All' | Company['status']) {
  const { data, loading } = useCollection<Company>(useMemo(() => query(companiesCol(), orderBy('name')), []), []);
  const filtered = useMemo(() => (status === 'All' ? data : data.filter((c) => c.status === status)), [data, status]);
  return { data: filtered, loading };
}
export const useCompany = (id: string | null) => useDoc<Company>(id ? companyDoc(id) : null);
export function useChildCompanies(id: string | null) {
  const { data, loading } = useCollection<Company>(useMemo(() => query(companiesCol(), orderBy('name')), []), []);
  const children = useMemo(() => (id ? data.filter((c) => c.parentCompanyId === id) : []), [data, id]);
  return { data: children, loading };
}
export const useCompanyActivity = (id: string | null) => useCollection<CompanyActivity>(useMemo(() => (id ? query(companyActivityCol(id), orderBy('at', 'desc')) : null), [id]), [id]);
